import {createSelector} from 'reselect';

export const getMembersByUserUUID = createSelector(
	props => props.community && props.community.members,
	members =>
		members &&
		members.reduce((accum, member) => {
			accum[member.user.uuid] = member;
			return accum;
		}, {})
);

export const getSessionUserMembership = createSelector(
	props => props.sessionProvider,
	getMembersByUserUUID,
	(sessionProvider, members) => {
		if (!sessionProvider || !members) return null;

		const member = members[sessionProvider.user.uuid];
		return member && member.membership;
	}
);

export const canAdmin = createSelector(
	props => props.sessionProvider,
	getSessionUserMembership,
	(session, sessionUserMembership) =>
		session &&
		((session.user && session.user.admin) || (sessionUserMembership && sessionUserMembership.admin))
);

export const getPendingMembers = createSelector(
	props => props.community && props.community.members,
	getSessionUserMembership,
	canAdmin,
	(members, isMember, isAdmin) =>
		members &&
		members.filter(
			member =>
				member.membership &&
				member.membership.status !== 'approved' &&
				(isAdmin || (isMember && member.subscriptionLevel !== 'none'))
		)
);

export const getApprovedMembers = createSelector(
	props => props.community && props.community.members,
	canAdmin,
	(members, isAdmin) =>
		members &&
		members.filter(
			member =>
				member.membership &&
				member.membership.status === 'approved' &&
				(isAdmin || member.subscriptionLevel !== 'none')
		)
);

export const getAdmins = createSelector(
	props => props.community && props.community.members,
	members =>
		members &&
		members.filter(
			member =>
				member.membership && member.membership.status === 'approved' && member.membership.admin
		)
);

// selector function to check if current user is admin of community or not
export const checkAdmin = createSelector(
	props => props.sessionProvider,
	getAdmins,
	(session, adminsList) => {
		if (adminsList && session && session.user) {
			const adminsUserUuid = adminsList.map(admin => {
				return admin.user.uuid;
			});

			const currentUserUuid = session.user.uuid;

			if (adminsUserUuid.includes(currentUserUuid)) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	}
);

const DEFAULT_CATEGORY = 'Other';

const groupByCategory = (members, isAdmin) => {
	if (!members) return members;

	return members.reduce((accum, provider) => {
		let category;

		if (isAdmin && provider.subscriptionLevel === 'none') {
			category = 'Users';
		} else {
			category = provider.category || DEFAULT_CATEGORY;
		}

		accum[category] = accum[category] || [];
		accum[category].push(provider);

		return accum;
	}, {});
};

export const getApprovedMembersByCategory = createSelector(
	getApprovedMembers,
	canAdmin,
	groupByCategory
);

export const getMembersByCategory = createSelector(
	props => props.community && props.community.members,
	canAdmin,
	groupByCategory
);

export const getSortedCategories = createSelector(
	getApprovedMembersByCategory,
	membersByCategory => membersByCategory && Object.keys(membersByCategory).sort()
);

export const getProfileUniqueName = props =>
	props && props.community && props.community.profile && props.community.profile.uniqueName;

export const getParamsUniqueName = props =>
	props && props.match && props.match.params && props.match.params.uniqueName;

export const getProviderUniqueName = props =>
	props &&
	props.session &&
	props.session.current &&
	props.session.current.provider &&
	props.session.current.provider &&
	props.session.current.provider.profile &&
	props.session.current.provider.profile.uniqueName;



// WEBPACK FOOTER //
// ./src/community/community.selectors.js